;(function ($) {
  "use strict"

  $(document).ready(function () {
    const $body = $("body")
    const $modal = $(".modal")
    const $backdrop = $(".backdrop")

    function toggleModal(element) {
      const isVisible = $modal.hasClass("is-visible")
      $modal.toggleClass("is-visible", !isVisible)
      $backdrop.fadeToggle(200)
      $body.toggleClass("no-scroll", !isVisible)
      if (!isVisible) {
        $modal.createTabTrap()
      } else {
        element.focus()
      }
    }

    $(document).on("click", function (event) {
      if (
        $(event.target).closest(".modal-open").length ||
        $(event.target).closest(".modal-close").length ||
        $(event.target).closest(".backdrop").length
      ) {
        event.preventDefault()

        toggleModal(event.target)
      }
    })

    $(document).on("keydown", function (event) {
      if (event.key === "Escape" && $modal.hasClass("is-visible")) {
        toggleModal(event.target)
      }
    })
  })
})(jQuery)
